import script from "./PathPresenter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PathPresenter.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__